import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import {
  Box,
  Flex,
  Grid,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  Spinner,
} from '@tq/ui-components';

interface CompletionModalContentProps {
  isLoading: boolean;
}

export const CompletionModalContent: React.FC<CompletionModalContentProps> = ({
  isLoading,
}) => {
  const { t } = useTranslation('report_completion_modal');

  return (
    <>
      <ModalHeader aria-label={t('report_completion_modal', 'Report completion modal')}>
        <Grid gridAutoFlow='column' gridGap={4}>
          <FaExclamationTriangle color={COLOURS.blue[600]} />
          <span>{t('complete_report', 'Complete report')}</span>
        </Grid>
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody overflow='visible' p='0 !important'>
        <Box
          bg={COLOURS.gray[100]}
          borderTop={`1px solid ${COLOURS.gray[300]}`}
          borderBottom={`1px solid ${COLOURS.gray[300]}`}
          px={8}
          py={4}
        >
          {isLoading ? (
            <Flex justifyContent='center'>
              <Spinner />
            </Flex>
          ) : (
            <p>
              {t(
                'complete_report_modal_warning',
                'Do you wish to complete the report? You will no longer be able to edit once you select complete.'
              )}
            </p>
          )}
        </Box>
      </ModalBody>
    </>
  );
};
